import { Button, Typography, Grid } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';

const ShowPassengersButton = ({ passengersCount, handleClick }) => {
  return (
    <Grid
      sx={{
        position: 'relative',
        marginRight: { xs: 0, md: '10px' },
        width: { xs: '100%', md: 'auto' },
      }}
      aria-controls="passengerMenu"
      aria-haspopup="true"
      onClick={handleClick}
    >
      <Button
        disableRipple
        sx={{
          background: '#fff',
          width: { xs: '100%', md: '55px' },
          height: '55px',
          border: '1px solid #C4C4C4',
          borderRadius: { xs: '4px', md: '8px' },
          color: '#636466',
          '&:hover': {
            background: 'none',
          },
        }}
      >
        <GroupIcon />
        <Typography
          variant="body2"
          sx={{
            color: '#636466',
            fontSize: { xs: '14px', md: '16px' },
            marginLeft: { xs: '30px', md: 0 },
          }}
        >
          {passengersCount}
        </Typography>
      </Button>
    </Grid>
  );
};

export default ShowPassengersButton;
